import { useIsAdminCookie } from '@/plugins/cookie-plugin'

export function useIsAdmin() {
    return useIsAdminCookie()
}
